<template>
  <div class="wraper">
    <div class="logo">
      <!-- <img v-if="store.getters.sideBarOpened"  src="@/assets/images/logo-white.png" alt="" /> -->
      <img :class="[sideBarOpened?'':'collapse']" v-if="orgUrl" :src="orgUrl" alt="" onerror="this.src='/images/logo-short.png'">
      <img :class="[sideBarOpened?'':'collapse']" v-else src="@/assets/images/logo-short.png" alt="">
      <div v-if="sideBarOpened" class="org-short-name" :title="orgName">{{orgName}}</div>
    </div>
    <div class="sidebar-search"><SearchText :collapsed="!sideBarOpened" /></div>
    <menu-bar></menu-bar>
  </div>
</template>
<script lang="ts">
import MenuBar from './MenuBar.vue'
import SearchText from '../SearchText.vue'
import store from '@/store'
import { defineComponent,computed } from 'vue'
export default defineComponent({
  components: {
    'menu-bar': MenuBar, SearchText,
  },
  setup(){
    const logoHeight = 40
    const sideBarOpened=computed(()=>{
      return store.getters.sideBarOpened
    })
    const orgName=computed(()=>{
      return store.getters.userInfo.orgShortName?store.getters.userInfo.orgShortName:""
    })
    const orgUrl=computed(()=>{
      return store.getters.userInfo.logoUrl?"https://allfiles.landiyun.com/"+store.getters.userInfo.logoUrl+'?x-oss-process=image/resize,w_200,m_lfit':''
    })
    return {
      store,logoHeight,orgName,orgUrl,sideBarOpened
    }
  }
})

</script>
<style lang="scss" scoped>
.sidebar-search{flex:0 0 auto;box-sizing:border-box;width:100%;max-width:100%;padding:0 8px 4px;min-width:0;color:#fff}
.sidebar-search :deep(.function-search-trigger){box-sizing:border-box;min-width:0;width:100%;max-width:100%;height:34px;padding:0 6px;gap:3px;font-size:12px;color:#fff;background:rgba(255,255,255,.12);border-color:rgba(255,255,255,.3)}
.sidebar-search :deep(.function-search-trigger:hover){background:rgba(255,255,255,.22);color:#fff;border-color:rgba(255,255,255,.55)}
.sidebar-search :deep(.function-search-trigger .anticon){font-size:16px;flex:0 0 16px}
.sidebar-search :deep(.function-search-trigger span:not(.anticon)){white-space:nowrap}
.sidebar-search :deep(.function-search-trigger kbd){font-size:10px;padding:0 2px;line-height:16px;opacity:.9;flex:0 0 auto}
.sidebar-search :deep(.function-search-trigger.collapsed){padding:0;justify-content:center}
.wraper { display:flex; flex-direction:column; height:100vh; min-height:0; }
.wraper :deep(.siderbar-menu) { flex:1; min-height:0; height:auto; }
.wraper :deep(.siderbar-menu > .ant-menu) { margin-top:0; padding-top:0; }
.wraper :deep(.siderbar-menu > .ant-menu > .ant-menu-submenu:first-child > .ant-menu-submenu-title),
.wraper :deep(.siderbar-menu > .ant-menu > .ant-menu-item:first-child) { margin-top:0; }
.wraper .logo {
 display:flex; align-items:center; justify-content:center; gap:2px;
 padding:6px 4px; box-sizing:border-box; color:white; min-height:60px; flex:0 0 auto;
 img { width:38px; height:38px; object-fit:contain; flex:0 0 38px; margin:0; }
 .org-short-name { flex:1; min-width:0; font-size:14px; line-height:1.4; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; text-align:left; }
 .collapse { width:38px; height:38px; }
}
</style>
